import React from "react"

interface FilterTagProps {
  label: string
  value: string
  onClear: () => void
}

export default function FilterTag({ label, value, onClear }: FilterTagProps) {
  return (
    <div className="inline-flex items-center gap-1 mr-2 mb-1">
      <span className="mr-1">{label}</span>
      <span className="bg-blue-500 text-white font-bold rounded-full px-2 py-[3px] inline-flex items-center">
        <span className="pb-[2px]">{value}</span>
        <button
          className="bg-transparent border-0 text-white font-extrabold ml-1 cursor-pointer p-0 leading-none"
          type="button"
          tabIndex={0}
          aria-label={`Clear ${label}`}
          onClick={onClear}
        >
          ×
        </button>
      </span>
    </div>
  )
}
